interface ColorSwatchesIconProps {
  className?: string;
  color?: string;
  strokeColor?: string;
  strokeWidth?: number;
}

const ColorSwatchesIcon = ({
  className = "w-5 h-5",
  color = "#D3D3D3",
  strokeColor = "#000000",
  strokeWidth = 1
}: ColorSwatchesIconProps) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clipPath="url(#clip0_261_4304)">
        <g>
          <path d="M17.8562 9.55625L11.0703 15.3011V2.35361C12.1762 1.63924 13.6677 1.76564 14.6372 2.73358L17.6702 5.76149C18.7209 6.81045 18.7813 8.43741 17.8562 9.55625Z" fill="white"/>
          <path d="M1.07031 11.4258V16.0686C1.07031 17.6466 2.3495 18.9258 3.92746 18.9258H8.21317C9.79113 18.9258 11.0703 17.6466 11.0703 16.0686V11.4258H1.07031Z" fill="white"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M6.78125 18.9281H16.067C17.645 18.9281 18.9241 17.6488 18.9241 16.0709V11.7852C18.9241 10.8829 18.5058 10.0783 17.8527 9.55469L11.067 15.2997V16.0708C11.067 17.6488 9.78778 18.9279 8.20982 18.9279L6.78125 18.9281Z" fill={color}/>
          <path fillRule="evenodd" clipRule="evenodd" d="M1.07031 3.92746V11.4275H11.0703V3.92746C11.0703 2.3495 9.79113 1.07031 8.21317 1.07031H3.92746C2.3495 1.07031 1.07031 2.3495 1.07031 3.92746Z" fill={color}/>
          <path d="M1.07031 16.0703V3.92746C1.07031 2.3495 2.3495 1.07031 3.92746 1.07031H8.21317C9.79113 1.07031 11.0703 2.3495 11.0703 3.92746V16.0703C11.0703 17.6483 9.79113 18.9275 8.21317 18.9275H3.92746C2.3495 18.9275 1.07031 17.6483 1.07031 16.0703Z" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M1.07031 11.4258V16.0686C1.07031 17.6466 2.3495 18.9258 3.92746 18.9258H8.21317C9.79113 18.9258 11.0703 17.6466 11.0703 16.0686V11.4258H1.07031Z" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M1.42969 11.4258H10.7154" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M1.42969 6.42578H10.7154" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6.07031 15.0469V15.3069" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6.78125 18.928H16.067C17.645 18.928 18.9241 17.6489 18.9241 16.0709V11.7852C18.9241 10.8829 18.5058 10.0783 17.8527 9.55469" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M17.6737 9.79821L11.0469 16.4361C11.0624 16.3156 11.0703 16.1928 11.0703 16.0682V2.34971C12.1762 1.63532 13.6677 1.76174 14.6372 2.72968L17.6702 5.75759C18.787 6.87244 18.7885 8.68148 17.6737 9.79821Z" stroke={strokeColor} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_261_4304">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default ColorSwatchesIcon;